export default __webpack_public_path__ + "static/media/home-logo.21a8bca1.png";